type InitRealtimeTrackingParams = {
  endpointUrl: string;
};

let endpointUrl = "";
const sessionCache: Record<string, boolean> = {};

export function initRealtimeTracking(params: InitRealtimeTrackingParams) {
  endpointUrl = params.endpointUrl;
}

export type PushRealtimeTrackingOptions = {
  sendOnce?: boolean;
};

export async function pushRealtimeTrackingCounter(
  eventName: string,
  labels: Record<string, string> = {},
  value = 1,
  options?: PushRealtimeTrackingOptions
) {
  return pushMetric("counter", eventName, labels, value, options);
}

export async function pushRealtimeTrackingHistogram(
  eventName: string,
  labels: Record<string, string> = {},
  value = 1,
  options?: PushRealtimeTrackingOptions
) {
  return pushMetric("histogram", eventName, labels, value, options);
}

async function pushMetric(
  metricType: "counter" | "histogram",
  eventName: string,
  labels: Record<string, string> = {},
  value = 1,
  options?: PushRealtimeTrackingOptions
) {
  eventName = eventName.replace(/[^a-z0-9]+/gi, "_");

  const bodyJSON = JSON.stringify({
    metricType,
    eventName,
    labels,
    value,
  });

  if (options?.sendOnce) {
    if (sessionCache[bodyJSON]) {
      return;
    }
    sessionCache[bodyJSON] = true;
  }

  return window?.fetch(endpointUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: bodyJSON,
    keepalive: true,
  });
}
